module.exports = __webpack_public_path__ + "static/media/fruits1.65d60c59.jpg";